import React, { useEffect, useState, useContext } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import axiosInstance from "../axios";
import { BusinessContext } from "../BusinessContext";
import { CircularProgress } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  TextField,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { Rating } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import ReviewsIcon from "@mui/icons-material/Reviews";
import RateReviewIcon from "@mui/icons-material/RateReview";
import BarChartIcon from "@mui/icons-material/BarChart";
import CollectionsIcon from "@mui/icons-material/Collections";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useTranslation } from "react-i18next";

const headerStyle = {
  fontFamily: "Roboto",
  fontSize: "16px",
  fontWeight: "500",
  color: "var(--pg-text)",
  backgroundColor: "var(--pg-surface-muted)",
  textAlign: "left",
};

const cellStyle = {
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: "400",
  color: "var(--pg-success)",
  px: "14px",
  py: "8px",
};

const businesscellStyles = {
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: "400",
  color: "var(--pg-text-muted)",
  px: "14px",
  py: "8px",
};

const cellStyless = {
  fontFamily: "Nunito",
  fontSize: "14px",
  fontWeight: "500",
  color: "var(--pg-accent-blue)",
  px: "14px",
  py: "8px",
};

function PlatesContent() {
  const [platesData, setPlatesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { selectedBusinessId } = useContext(BusinessContext);
  const [openReviewCountModal, setOpenReviewCountModal] = useState(false);
  const [reviewCountDate, setReviewCountDate] = useState("");
  const [reviewCountCount, setReviewCountCount] = useState("");
  const [reviewCountRating, setReviewCountRating] = useState(0);
  const [
    selectedBusinessIdForReviewCount,
    setSelectedBusinessIdForReviewCount,
  ] = useState(null);
  const [ratingCountError, setRatingCountError] = useState(false);
  const [countCountError, setCountCountError] = useState(false);
  const [dateCountError, setDateCountError] = useState(false);
  const [loadingReviewCount, setLoadingReviewCount] = useState(false);
  //review modal
  const [openReviewModal, setopenReviewModal] = useState(false);
  const [selectedBusinessIdForReview, setSelectedBusinessIdForReview] =
    useState(null);
  const [reviewDate, setReviewDate] = useState("");
  const [reviewname, setReviewName] = useState("");
  const [reviewRating, setReviewRating] = useState(0);
  const [ratingError, setRatingError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [reviewComment, setReviewComment] = useState("");
  const [commentError, setCommentError] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [loadingReview, setLoadingReview] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchPlates = async () => {
      if (!selectedBusinessId) {
        setLoading(false); // Stop loading
        setPlatesData([]); // Set empty array
        return;
      }
      setLoading(true);
      try {
        const response = await axiosInstance.post(
          "orders.php?method=get_plates",
          {
            business_id: selectedBusinessId,
          }
        );
        if (response.data?.plates) {
          setPlatesData(response.data?.plates);
        } else {
          console.error("No plates found in response");
          setPlatesData([]);
        }
      } catch (error) {
        console.error("Error fetching plates:", error);
        setPlatesData([]);
      }
      setLoading(false);
    };
    fetchPlates();
  }, [selectedBusinessId]);

  const handleCloseReviewcountModal = () => {
    setOpenReviewCountModal(false);
    setReviewCountRating("");
    setReviewCountDate("");
    setReviewCountCount("");
    setRatingCountError(false);
    setCountCountError(false);
    setDateCountError(false);
    setSelectedBusinessIdForReviewCount(null);
  };
  const handleSaveReviewcount = async () => {
    // Reset all errors first
    setRatingCountError(false);
    setCountCountError(false);
    setDateCountError(false);

    let hasError = false;

    // Validation for rating
    if (
      !reviewCountRating ||
      isNaN(reviewCountRating) ||
      Number(reviewCountRating) > 5 ||
      !/^([0-4](\.\d{1})?|5(\.0)?)$/.test(reviewCountRating)
    ) {
      setRatingCountError(true);
      hasError = true;
    }

    // Validation for count
    if (!reviewCountCount || Number(reviewCountCount) <= 0) {
      setCountCountError(true);
      hasError = true;
    }

    // Validation for date
    if (!reviewCountDate) {
      setDateCountError(true);
      hasError = true;
    }

    if (hasError) return;

    const payload = {
      business_id: selectedBusinessIdForReviewCount,
      provider: "review",
      rating: reviewCountRating.toString(),
      created_at: reviewCountDate,
      review_count: reviewCountCount.toString(),
    };

    setLoadingReviewCount(true);

    try {
      await axiosInstance.post("orders.php?method=add_review", payload);
      toast.success("Review added successfully!");
      handleCloseReviewcountModal(); // Reset everything
    } catch (error) {
      console.error("Error adding review:", error);
      toast.error("Error while adding review.");
    } finally {
      setLoadingReviewCount(false);
    }
  };

  const handleCloseReviewModal = () => {
    setopenReviewModal(false);
    setReviewRating("");
    setReviewDate("");
    setReviewName("");
    setReviewComment("");
    setRatingError(false);
    setNameError(false);
    setCommentError(false);
    setDateError(false);
    setSelectedBusinessIdForReview(null);
  };

  const handleSaveReview = async () => {
    // Reset all errors first
    setRatingError(false);
    setCommentError(false);
    setNameError(false);
    setDateError(false);

    let hasError = false;

    // Validation for rating
    if (
      !reviewRating ||
      isNaN(reviewRating) ||
      Number(reviewRating) > 5 ||
      !/^([0-4](\.\d{1})?|5(\.0)?)$/.test(reviewRating)
    ) {
      setRatingError(true);
      hasError = true;
    }

    // Validation for count
    if (!reviewname.trim()) {
      setNameError(true);
      hasError = true;
    }

    // Validation for date
    if (!reviewDate) {
      setDateError(true);
      hasError = true;
    }

    if (hasError) return;
   
    
   const payload = {
      business_id: selectedBusinessIdForReview,
      rating: reviewRating.toString(),
      created_at: reviewDate.replace("T", " "),
      author_name: reviewname.trim(),
      comment: reviewComment.trim() || "",
    };

    setLoadingReview(true);

    try {
      await axiosInstance.post("places.php?method=insert_review", payload);
      toast.success("Review added successfully!");
      handleCloseReviewModal(); // Reset everything
    } catch (error) {
      console.error("Error adding review:", error);
      toast.error("Error while adding review.");
    } finally {
      setLoadingReview(false);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuBusinessId, setMenuBusinessId] = useState(null);

  const handleMenuClick = (event, businessId) => {
    setAnchorEl(event.currentTarget);
    setMenuBusinessId(businessId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuBusinessId(null);
  };
  const handleViewClick = (businessId) => {
    navigate(`/dashboard/viewclicks/${businessId}`);
  };
  const handleNetworks = (businessId, businessName, businessAddress) => {
    navigate(`/dashboard/networks/${businessId}`, {
      state: { name: businessName, address: businessAddress },
    });
  };

  const handleBusinessPhotos = (businessId, businessName, businessAddress) => {
    navigate(`/dashboard/businessphotos/${businessId}`, {
      state: { name: businessName, address: businessAddress },
    });
  };

  const handleBusinessGraphs = (businessId, businessName, businessAddress) => {
    navigate(`/dashboard/businessgraphs/${businessId}`, {
      state: { name: businessName, address: businessAddress },
    });
  };

  const handleBusinessMenu = (businessId, businessName, businessAddress) => {
    navigate(`/dashboard/businessmenu/${businessId}`, {
      state: { name: businessName, address: businessAddress },
    });
  };
  return (
    <Box paddingLeft={"30px"}>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="90vh"
          p={3}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontSize: { xs: "24px", sm: "28px" },
              fontWeight: "600",
              lineHeight: "16px",
              color: "var(--pg-text)",
              px: "14px",
              pb: "25px",
              pt: "14px",
            }}
          >
           {t("Business Reports")}
          </Typography>
          <TableContainer
            component={Paper}
            sx={{ maxWidth: { xs: "90%", sm: "max-content" }, mt: 2 }}
          >
            <Table sx={{ width: { xs: "max-content", sm: "100%" } }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={headerStyle}>{t("Business Name")}</TableCell>
                  <TableCell sx={headerStyle}>{t("Genie Tag")}</TableCell>
                  <TableCell sx={headerStyle}>{t("Scans")}</TableCell>
                  <TableCell sx={headerStyle}>{t("Actions")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {platesData.length > 0 ? (
                  platesData.map((plate, index) => {
                    const plateList = plate.plates
                      .split(",")
                      .map((p) => p.trim())
                      .filter(Boolean);
                    const plateChunks = [];
                    for (let i = 0; i < plateList.length; i += 2) {
                      plateChunks.push(plateList.slice(i, i + 2));
                    }

                    return (
                      <TableRow key={index}>
                        <TableCell sx={{businesscellStyles, width:{xs:"40%",sm:"40%"}}} >
                          <div>
                            <div >
                              <Typography sx={{color:"var(--pg-text)",fontFamily:"Roboto",lineHeight:"18px"}}>
                              {plate.name}
                              </Typography>
                              <Typography sx={{fontSize:"14px",fontFamily:"Roboto",fontWeight:"400",color:"var(--pg-text-muted)"}}>
                              {plate.address}
                              </Typography>
                            </div>
                            <div
                              style={{
                                fontSize: "0.90em",
                                color: "var(--pg-text-muted)",
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                                fontWeight:"500"
                              }}
                            >
                              {plate.rating}{" "}
                              {plate.review_count && (
                                <>
                                  ({plate.review_count} reviews)
                                  </>
                              )}
                             {plate.rating && (
                              <Rating
                                value={parseFloat(plate.rating)}
                                readOnly
                                precision={0.1}
                                sx={{ fontSize: "14px" }}
                              />
                             )}
                              
                            </div>
                          </div>
                        </TableCell>

                        <TableCell sx={cellStyless}>
                          {plateChunks.map((chunk, idx) => (
                            <div key={idx}>
                              {chunk.map((code, i) => (
                                <span
                                  key={i}
                                  onClick={() =>
                                    window.open(
                                      `${window.location.origin}/r/code=${code}`,
                                      "_blank"
                                    )
                                  }
                                  style={{
                                    color: "var(--pg-accent-blue)",
                                    cursor: "pointer",
                                    marginRight: "8px",
                                  }}
                                >
                                  {code}
                                </span>
                              ))}
                            </div>
                          ))}
                        </TableCell>

                        <TableCell sx={cellStyle}>{plate.totalscans}</TableCell>
                        <TableCell sx={cellStyle}>
                           {/* <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 1,
                                flexWrap: "nowrap",
                              }}
                            >
                              <Tooltip title= {t("Add Review Count")}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{
                                  fontSize: "12px",
                                  minWidth: "auto",
                                  px: 1,
                                  whiteSpace: "nowrap",
                                  textTransform: "capitalize",
                                  fontFamily: "Roboto",
                                }}
                                // startIcon={}
                                onClick={() => {
                                  setOpenReviewCountModal(true);
                                  setSelectedBusinessIdForReview(plate.id);
                                }}
                              >
                               <AddIcon />
                              </Button>
                              </Tooltip>
                              <Tooltip title= {t("Add Menu")}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{
                                  fontSize: "12px",
                                  minWidth: "auto",
                                  px: 1,
                                  whiteSpace: "nowrap",
                                  textTransform: "capitalize",
                                  fontFamily: "Roboto",
                                }}
                               
                                onClick={() => handleBusinessMenu( plate.id,
                                  plate.name,
                                  plate.address)}
                              >
                               <MenuIcon />
                              </Button> 
                              </Tooltip>
                              <Tooltip title= {t("Add Review")}>                        
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{
                                  fontSize: "12px",
                                  minWidth: "auto",
                                  px: 1,
                                  whiteSpace: "nowrap",
                                  textTransform: "capitalize",
                                  fontFamily: "Roboto",
                                }}
                               
                                onClick={() => {
                                  setopenReviewModal(true);
                                  setSelectedBusinessIdForReview(plate.id);
                                }}
                              >
                                <ReviewsIcon />
                              </Button>
                              </Tooltip>  
                              <Tooltip title= {t("View Clicks")}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{
                                  fontSize: "12px",
                                  minWidth: "auto",
                                  px: 1,
                                  whiteSpace: "nowrap",
                                  textTransform: "capitalize",
                                  fontFamily: "Roboto",
                                }}
                                onClick={() => handleViewClick(plate.id)}
                              >
                               <AdsClickIcon />
                              </Button>
                              </Tooltip>
                           </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 1,
                                flexWrap: "nowrap",
                              }}
                            >
                              <Tooltip title={t("Networks")}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{
                                  fontSize: "12px",
                                  minWidth: "auto",
                                  px: 1,
                                  whiteSpace: "nowrap",
                                  textTransform: "capitalize",
                                  fontFamily: "Roboto",
                                }}
                                onClick={() =>
                                  handleNetworks(
                                    plate.id,
                                    plate.name,
                                    plate.address
                                  )
                                }
                              >
                               <RateReviewIcon /> 
                              </Button>
                              </Tooltip>
                              <Tooltip title= {t("Photos")}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{
                                  fontSize: "12px",
                                  minWidth: "auto",
                                  px: 1,
                                  whiteSpace: "nowrap",
                                  textTransform: "capitalize",
                                  fontFamily: "Roboto",
                                }}
                                
                                onClick={() =>
                                  handleBusinessPhotos(
                                    plate.id,
                                    plate.name,
                                    plate.address
                                  )
                                }
                              >
                               <CollectionsIcon />
                              </Button>
                              </Tooltip>
                              <Tooltip title={t("Graphs")}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{
                                  fontSize: "12px",
                                  minWidth: "auto",
                                  px: 1,
                                  whiteSpace: "nowrap",
                                  textTransform: "capitalize",
                                  fontFamily: "Roboto",
                                }}
                                onClick={() =>
                                  handleBusinessGraphs(
                                    plate.id,
                                    plate.name,
                                    plate.address
                                  )
                                }
                              >
                               <BarChartIcon />
                              </Button>
                              </Tooltip>
                            </Box>
                          </Box> */}
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={(e) => handleMenuClick(e, plate.id)}
                            sx={{
                              textTransform: "capitalize",
                              fontSize: "13px",
                              fontWeight: 500,
                              fontFamily: "Roboto",
                              borderRadius: "8px",
                              paddingRight: "0px", // optional if extra spacing exists
                            }}
                          >
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                            >
                           {t("Actions")}
                              <KeyboardDoubleArrowRightIcon style={{ marginLeft: -2,fontSize:"20px" }} />
                            </span>
                          </Button>

                          <Menu
                            anchorEl={anchorEl}
                            open={
                              Boolean(anchorEl) && menuBusinessId === plate.id
                            }
                            onClose={handleMenuClose}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            PaperProps={{
                              elevation: 3,
                              sx: {
                                borderRadius: "12px",
                                minWidth: "200px",
                                mt: 1,
                              },
                            }}
                          >
                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                setOpenReviewCountModal(true);
                                setSelectedBusinessIdForReviewCount(plate.id);
                              }}
                            >
                              <ListItemIcon>
                                <AddIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>
                              {t("Add Review Count")}
                              </ListItemText>
                            </MenuItem>

                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                handleBusinessMenu(
                                  plate.id,
                                  plate.name,
                                  plate.address
                                );
                              }}
                            >
                              <ListItemIcon>
                                <MenuBookIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{t("Add Menu")}</ListItemText>
                            </MenuItem>

                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                handleViewClick(plate.id);
                              }}
                            >
                              <ListItemIcon>
                                <AdsClickIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{t("View Clicks")}</ListItemText>
                            </MenuItem>

                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                setopenReviewModal(true);
                                setSelectedBusinessIdForReview(plate.id);
                              }}
                            >
                              <ListItemIcon>
                                <ReviewsIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{t("Add Review")}</ListItemText>
                            </MenuItem>

                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                handleNetworks(
                                  plate.id,
                                  plate.name,
                                  plate.address
                                );
                              }}
                            >
                              <ListItemIcon>
                                <RateReviewIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{t("Networks")}</ListItemText>
                            </MenuItem>

                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                handleBusinessPhotos(
                                  plate.id,
                                  plate.name,
                                  plate.address
                                );
                              }}
                            >
                              <ListItemIcon>
                                <CollectionsIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{t("Photos")}</ListItemText>
                            </MenuItem>

                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                handleBusinessGraphs(
                                  plate.id,
                                  plate.name,
                                  plate.address
                                );
                              }}
                            >
                              <ListItemIcon>
                                <BarChartIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{t("Graphs")}</ListItemText>
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      sx={{ textAlign: "center", py: 2, fontWeight: 600 }}
                    >
                      {t("No Data Available")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

      {/* Review count Modal */}
      <Dialog open={openReviewCountModal} onClose={handleCloseReviewcountModal}>
        <Box p={3} minWidth="350px" position="relative">
          <Box
            position="absolute"
            top={8}
            right={8}
            sx={{ cursor: "pointer" }}
            onClick={handleCloseReviewcountModal}
          >
            <Typography variant="h6" fontWeight="bold" color="gray">
              <CloseIcon fontSize="medium" />
            </Typography>
          </Box>

          <Typography variant="h6" mb={3} textAlign="center">
          {t("Add Review Count")}
          </Typography>
          {/* <Typography
            sx={{
              mb: 1,
              fontWeight: 500,
              fontSize: "15px",
              color: "#555",
            }}
          >
            {t("Rating")}
          </Typography> */}
          <TextField
            label="Rating (0.0 - 5.0)"
            type="number"
            inputProps={{ step: "0.1", min: "0", max: "5" }}
            fullWidth
            value={reviewCountRating}
            onChange={(e) => {
              const value = e.target.value;
              setReviewCountRating(value);

              // live validation: clear error if valid
              if (
                value &&
                !isNaN(value) &&
                Number(value) <= 5 &&
                /^([0-4](\.\d{1})?|5(\.0)?)$/.test(value)
              ) {
                setRatingCountError(false);
              }
            }}
            error={ratingCountError}
            helperText={
              ratingCountError ? "Enter a valid rating (e.g., 4.5)" : ""
            }
            sx={{ mb: 2 }}
          />

          <TextField
            label="Review Count"
            type="number"
            fullWidth
            value={reviewCountCount}
            onChange={(e) => {
              const value = e.target.value;
              setReviewCountCount(value);

              if (value && Number(value) > 0) {
                setCountCountError(false);
              }
            }}
            error={countCountError}
            helperText={countCountError ? "Review count is required" : ""}
            sx={{ mb: 2 }}
          />

          <TextField
            label="Date"
            type="date"
            fullWidth
            value={reviewCountDate}
            onChange={(e) => {
              const value = e.target.value;
              setReviewCountDate(value);

              if (value) {
                setDateCountError(false);
              }
            }}
            InputLabelProps={{ shrink: true }}
            error={dateCountError}
            helperText={dateCountError ? "Date is required" : ""}
            sx={{ mb: 2 }}
          />

          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              sx={{ width: "150px", fontFamily: "Roboto" }}
              onClick={handleSaveReviewcount}
              disabled={loadingReviewCount}
            >
              {loadingReviewCount ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                t("Save")
              )}
            </Button>
          </Box>
        </Box>
      </Dialog>
      {/* give review  Modal */}
      <Dialog open={openReviewModal} onClose={handleCloseReviewModal}>
        <Box p={3} minWidth="350px" position="relative">
          <Box
            position="absolute"
            top={8}
            right={8}
            sx={{ cursor: "pointer" }}
            onClick={handleCloseReviewModal}
          >
            <Typography variant="h6" fontWeight="bold" color="gray">
              <CloseIcon fontSize="medium" />
            </Typography>
          </Box>

          <Typography variant="h6" mb={3} textAlign="center">
          {t("Add Review")}
          </Typography>
          {/* <Typography
            sx={{
              mb: 1,
              fontWeight: 500,
              fontSize: "15px",
              color: "#555",
            }}
          >
            {t("Rating")}
          </Typography> */}
          <TextField
            label="Rating (0.0 - 5.0)"
            type="number"
            inputProps={{ step: "0.1", min: "0", max: "5" }}
            fullWidth
            value={reviewRating}
            onChange={(e) => {
              const value = e.target.value;
              setReviewRating(value);

              // live validation: clear error if valid
              if (
                value &&
                !isNaN(value) &&
                Number(value) <= 5 &&
                /^([0-4](\.\d{1})?|5(\.0)?)$/.test(value)
              ) {
                setRatingError(false);
              }
            }}
            error={ratingError}
            helperText={ratingError ? "Enter a valid rating (e.g., 4.5)" : ""}
            sx={{ mb: 2 }}
          />

          <TextField
            label="Name"
            type="text"
            fullWidth
            value={reviewname}
            onChange={(e) => {
              const value = e.target.value;
              setReviewName(value);

              if (value.trim()) {
                setNameError(false); // ✅ Correct state to update
              }
            }}
            error={nameError}
            helperText={nameError ? "Name is required" : ""}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Comment"
            multiline
            rows={4}
            fullWidth
            value={reviewComment}
            onChange={(e) => {
              const value = e.target.value;
              setReviewComment(value);

              if (value.trim()) {
                setCommentError(false);
              }
            }}
            error={false}
            helperText= ""
            sx={{ mb: 2 }}
          />

          <TextField
            label="Date & Time"
            type="datetime-local"
            fullWidth
            value={reviewDate}
            onChange={(e) => {
              const value = e.target.value;
              setReviewDate(value);

              if (value) {
                setDateError(false);
              }
            }}
            InputLabelProps={{ shrink: true }}
            error={dateError}
            helperText={dateError ? "Date & Time is required" : ""}
            sx={{ mb: 2 }}
          />

          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              sx={{ width: "150px", fontFamily: "Roboto" }}
              onClick={handleSaveReview}
              disabled={loadingReview}
            >
              {loadingReview ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                t("Save")
              )}
            </Button>
          </Box>
        </Box>
      </Dialog>
      <ToastContainer position="top-center" autoClose={2000} />
    </Box>
  );
}

export default PlatesContent;
